export default "./icons/w.png";